import { useEffect } from 'react';

import { electronApis } from '@/features/electron-api';
import { inElectron } from '@/utils/capabilities';

import { ensureMeetingNotActiveForAction } from './meeting-guard';

export function MeetingQuitGuard() {
  useEffect(() => {
    if (!inElectron()) return;

    return electronApis.meetings.listenQuitBlockedByMeeting(async () => {
      await ensureMeetingNotActiveForAction('quit');
    });
  }, []);

  return null;
}
